var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 107,
    viewBox: "0 0 125 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "supergraphic-delta-mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0 64.6008L 60.7775 93.9737L 0 0L 0 64.6008Z",
    transform: "matrix(0.544639 0.838671 -0.838671 0.544639 124.622 -5.98828)",
    fill: "#8B2332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0 27.8234L 65.5947 27.8234L 0 0L 0 27.8234Z",
    transform: "matrix(0.544639 0.838671 -0.838671 0.544639 59.7297 36.1533)",
    fill: "#8B2332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 60.7899 0L 0 93.9752L 60.7899 64.6023L 60.7899 0Z",
    transform: "matrix(0.544639 0.838671 -0.838671 0.544639 91.5151 -56.9717)",
    fill: "#CF0A2C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0 27.8234L 65.5931 27.8234L 65.5931 0L 0 27.8234Z",
    transform: "matrix(0.544639 0.838671 -0.838671 0.544639 24.0049 -18.8574)",
    fill: "#CF0A2C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8cac48a54b8c233182cf343f740e3b08.svg";
export { ForwardRef as ReactComponent };